import { ExchangeError } from '../../../errors.js';
const SERVER = new URL('https://api2.criptointercambio.com');
class CicError extends ExchangeError {
    name = 'CicError';
}
const getCicOrder = async ({ message, headers, signature, }, fetchival) => {
    const response = await fetchival(SERVER, {
        headers: { ...headers, sign: signature },
    }).post(message);
    if (!response?.result) {
        throw new CicError({ message: JSON.stringify(response) });
    }
    return response.result[0];
};
const getProviderOrder = async (providerOrder, fetchival) => {
    if (!providerOrder.options?.statusRequestParams) {
        throw new CicError({ message: 'Missing headers for CIC' });
    }
    const orderInfo = await getCicOrder(providerOrder.options.statusRequestParams, fetchival);
    return {
        orderId: orderInfo.id,
        depositAddress: orderInfo.payinAddress,
        depositAmount: orderInfo.amountExpectedFrom,
        withdrawalAddress: orderInfo.payoutAddress,
    };
};
const cicConfig = {
    cic: getProviderOrder,
    cicus: getProviderOrder,
};
export default cicConfig;
